import React, { createContext } from 'react'
import { supabaseClient } from './supabase'

export const SupabaseContext = createContext(supabaseClient)

export const SupabaseContextProvider = (props: React.PropsWithChildren<{}>) => (
  <SupabaseContext.Provider value={supabaseClient} {...props} />
)
